import { $ as SortingExecutionSide, $t as moduleFilterComponentToCoreFilterComponentView, A as ViewModelStandardAction, At as FilteringExecutionSide, B as LookupMainMode, Bt as enumOperators, C as FilterValue, Cn as getApiClientBaseUrl, Ct as SortDirection, D as ReferenceRetrievingTrigger, Dt as Group, E as isEnumMember, Et as GroupDescription, F as ViewModelActionLocationEntry, Ft as FilterOperator, G as getLookupPropertyFilter, Gt as isFilterOperatorWithoutValue, H as LookupTemplateMode, Ht as guidOperators, I as ViewModelActionLocation, It as allOperators, J as getLookupSearchProperty, Jt as moduleFilterOperatorToCoreFilterOperator, K as getLookupPropertyPath, Kt as isStandardFilterOperator, L as ViewModelActionDisplayMode, Lt as booleanOperators, M as ViewModelActionType, Mt as uiViewEvents, N as ViewModelActionStyle, Nt as ViewModelEntityViewParameters, O as ViewModelActions, Ot as FrameDisplayMode, P as ViewModelActionSize, Pt as ViewModelEntityViewParameter, Q as SummaryResult, Qt as FilterComponent, R as ViewModelActionConstraint, Rt as coreFilterOperatorToModuleFilterOperator, S as formatValues, Sn as getApiClient, St as ObservableList, T as ContentAlign, Tt as GroupingExecutionSide, U as getLookupDisplayProperty, Ut as isArrayFilterOperator, V as LookupSearchMode, Vt as getAllowedOperators, W as getLookupEditingUIViewId, Wt as isFilterOperatorOnLookupValueProperty, X as isLookupContainsSearchActive, Xt as numberOperators, Y as isInputValueWithWildcards, Yt as nullableOperators, Z as GroupSummaryResult, Zt as stringOperators, _ as ViewModelPropertyBase, _n as FileReference, _t as NavigationParameters, an as runWithEvent, at as Reporting, b as formatLookupScalarValueSync, bn as ServerMethodError, bt as ListChangedType, c as FetchError, cn as ToggleOverlayOptions, ct as reactive, d as FilterCondition, dn as ConstraintValidationMessage, dt as writableComputed, en as BaseComponentViewModel, et as Sort, f as FilterFunction, fn as ValidationMessage, ft as NavigationResult, g as ViewModelProperties, gn as RelationType, gt as NavigationTarget, h as ViewModel, hn as ValidationRuleValidationTypes, ht as NavigationOptions, i as createSerializationPlugin, in as navigate, it as PrivateBaseReportOptions, j as ViewModelActionBase, jt as ServerDataExportOptions, k as ExportFormat, kt as FilterLogicalOperator, l as Model, ln as runWithGlobalMenuItemContext, lt as setReactivity, m as StatusFilterMode, mn as ValidationRuleSeverityLevel, mt as NavigationResultState, nn as ViewModelMessageButton, nt as ExecuteReportOptions, on as showToast, ot as computed, p as DeletionMode, pn as ValidationRuleValidationMessage, pt as NavigationResultWithoutValue, q as getLookupSearchFilter, qt as localizableStringOperators, r as registerCustomSerializationPlugins, rn as ViewModelError, rt as AbstractReportOptions, s as FetchApiClient, sn as toggleOverlay, st as hasReactivity, t as ExpressionSort, tn as ViewModelMessageButtonType, tt as BaseSort, u as Filter, un as ApiErrorMessageOverrider, ut as watch, v as formatLookupReferenceValue, vn as FileUploadState, vt as ServerGroup, w as FilterOperation, wn as registerApiClient, wt as GroupList, x as formatValue, xn as ApiParameterBinding, xt as ListLoadingState, y as formatLookupScalarValue, yn as ViewModelMessageType, yt as SummaryDescription, z as ViewModelActionBadgeSeverity, zt as dateOperators } from "./ExpressionSort-D7xXNwAK.js";
import { DataType, Device, PopupPosition, PopupSize, compareArray, createGuid, createLocalEvent, createRegistry, defaultJsonReviver, getArraySearchFunction, getBaseUrl, getEventManager, getGlobalResourceManager, postMessageToVsCode, setBaseUrl, setViewType, stringFormat, toCamelCase } from "@neos/shared";
import { HubConnectionBuilder, JsonHubProtocol, LogLevel } from "@microsoft/signalr";
//#region src/componentViewModel/ComponentViewModel.ts
/**
* Represents the view model of an UI component.
*/
var ComponentViewModel = class extends BaseComponentViewModel {
	/**
	* Gets the highest view model in the view.
	*/
	get mainViewModel() {
		return this.parentViewModel.mainViewModel;
	}
	/**
	* Gets the typed mainViewModel.
	* @returns
	*/
	getMainViewModel() {
		return this.mainViewModel;
	}
	/**
	* Gets the typed parentViewModel.
	* @returns
	*/
	getParentViewModel() {
		return this.parentViewModel;
	}
	/**
	* Initializes a new instance of the ViewModelComponent class.
	* @param options - Options.
	*/
	constructor(options) {
		super(options.parentViewModel.applicationContext, options.parentViewModel.eventManager, options.parentViewModel.localizator, options.parentViewModel.globalResourceManager, options.parentViewModel.apiClient, options.notifications, options.logger, options.parentViewModel.resourceManager, options.wrapInstance);
		this.computeds = { owner: this };
		this.parameterChangedHandler = {};
		this.parentViewModel = options.parentViewModel;
		return this.wrapInstance(this);
	}
	/**
	* Initializes.
	*/
	async initAsync() {
		super.init();
		await this.runExpressionAndLogAsync("onInitialized", this.onInitialized);
	}
	/**
	* Disposes.
	*/
	async disposeAsync() {
		super.dispose();
		await this.runExpressionAndLogAsync("onDisposed", this.onDisposed);
	}
	/**
	* Raise parameter changed event.
	*
	* @param parameterName - Parameter name.
	* @param value - Value.
	* @param oldValue - Old value.
	*/
	async onParameterChanged(parameterName, value, oldValue) {
		await this.runExpressionAndLogAsync(`parameterChanged[${parameterName}]`, this.parameterChangedHandler[parameterName], {
			parameterName,
			value,
			oldValue
		});
	}
	/**
	* Toggles an overlay.
	*/
	toggleOverlay(idOrOptions) {
		toggleOverlay(this.parentViewModel, idOrOptions);
	}
	/**
	* Navigates to a view.
	* @param options - Navigation options.
	*/
	async navigateAsync(options) {
		options.callerRemote = this.parentViewModel.getRemote()?.name;
		navigate(this.eventManager, options);
	}
};
//#endregion
//#region src/componentViewModel/ComponentViewModelComputed.ts
/**
* Represents the view model of a UI component computed.
*/
var ComponentViewModelComputed = class {
	/**
	* Initialize a new ViewModelComputed instance.
	*
	* @param owner - ViewModel owning the field.
	*/
	constructor(owner) {
		this.owner = owner;
	}
};
//#endregion
//#region src/componentViewModel/ComponentViewModelParameters.ts
/**
* Represents the parameters of the UI component view model.
*/
var ComponentViewModelParameters = class {
	/**
	* Initializes a new instace of the ViewModelComponentParameters class.
	* @param getParameterValue - Method for reading the value of the parameter.
	* @param setParameterValue - Method for setting the value of the parameter.
	*/
	constructor(getParameterValue, setParameterValue) {
		this.getParameterValue = getParameterValue;
		this.setParameterValue = setParameterValue;
	}
};
//#endregion
//#region src/context/ApplicationContext.ts
var ApplicationContext = class extends Map {
	constructor(..._args) {
		super(..._args);
		this._apiContextValues = /* @__PURE__ */ new Map();
		this._onChangedCallbacks = /* @__PURE__ */ new Map();
	}
	get webApiTimeout() {
		return this.get("WebApiTimeout");
	}
	get editedCluster() {
		return this.get("EditedCluster");
	}
	get clusterName() {
		return this.get("ClusterName");
	}
	get clusterTitle() {
		return this.get("ClusterTitle");
	}
	get clusterVersion() {
		return this.get("ClusterVersion");
	}
	get clusterCompany() {
		return this.get("ClusterCompany");
	}
	get clusterInProduction() {
		return this.get("ClusterInProduction");
	}
	get uiDefaultBehavior() {
		return this.get("UIDefaultBehavior") ?? {};
	}
	get urlPrefix() {
		return this.get("UrlPrefix");
	}
	get userIdentifier() {
		return this.get("UserIdentifier");
	}
	get userEmail() {
		return this.get("UserEmail");
	}
	get userFirstName() {
		return this.get("UserFirstName");
	}
	get userLastName() {
		return this.get("UserLastName");
	}
	get userCustomViewMode() {
		return this.get("UserCustomViewMode");
	}
	get userCanAssignDefaultCustomView() {
		return this.get("UserCanAssignDefaultCustomView");
	}
	get tenants() {
		return this.get("Tenants");
	}
	get tenant() {
		return this.get("TenantInfo");
	}
	get theme() {
		return this.get("Theme");
	}
	get menuItems() {
		return this.get("Menus.$All");
	}
	get tenantIdentifier() {
		return this.getApiContextValue("Tenant", null);
	}
	get debug() {
		return this.get("Debug");
	}
	get(key) {
		const value = super.get(key);
		if (value !== void 0) return value;
		return this.parent?.get(key);
	}
	setTenantIdentifier(value) {
		this.setApiContextValue("Tenant", value);
	}
	addValue(key, value) {
		if (this.has(key)) throw new Error(`The key "${key}" is already in the application context.`);
		this.set(key, value);
	}
	getValue(key, defaultValue) {
		return this.get(key) ?? defaultValue;
	}
	getMenuItems(menuName) {
		return this.get(`Menus.${menuName}`);
	}
	/**
	* Adds a listener to be called when the value of the given key changes.
	* @param key The key to listen to.
	* @param callback The callback to be called when the value changes.
	*/
	addListenerOnValueChanged(key, callback) {
		const callbacks = this._onChangedCallbacks.get(key);
		if (callbacks) callbacks.push(callback);
		else this._onChangedCallbacks.set(key, [callback]);
	}
	/**
	* Removes a listener to be called when the value of the given key changes.
	* @param key The key to listen to.
	* @param callback The callback to be called when the value changes.
	*/
	removeListenerOnValueChanged(key, callback) {
		const callbacks = this._onChangedCallbacks.get(key);
		if (callbacks) {
			const index = callbacks.indexOf(callback);
			if (index !== -1) callbacks.splice(index, 1);
		}
	}
	/**
	* Sets the value of the given key.
	* @param key The key to set.
	* @param value The value to set.
	* @returns The ApplicationContext instance.
	* @override set from Map class
	*/
	set(key, value) {
		super.set(key, value);
		const callbacks = this._onChangedCallbacks?.get(key);
		if (callbacks) for (const callback of callbacks) callback(value);
		return this;
	}
	addApiContextValue(key, value) {
		if (this._apiContextValues.has(key)) throw new Error(`The key "${key}" is already in the API context.`);
		return this.setApiContextValue(key, value);
	}
	setApiContextValue(key, value) {
		if (__NEOS_STUDIO_VSCODE__ && (!this._apiContextValues.has(key) || this._apiContextValues.get(key) !== value)) this.notifyVsCode(key, value, "updated");
		this._apiContextValues.set(key, value);
	}
	getApiContextValue(key, defaultValue) {
		const value = this._apiContextValues.get(key);
		if (value !== void 0) return value;
		if (this.parent) return this.parent.getApiContextValue(key, defaultValue);
		return defaultValue;
	}
	getAllApiContextValues() {
		const result = this.parent?.getAllApiContextValues() ?? {};
		for (const [key, value] of this._apiContextValues) result[`neos-${key}`] = value;
		return result;
	}
	deleteApiContextValue(key) {
		if (__NEOS_STUDIO_VSCODE__ && this._apiContextValues.has(key)) this.notifyVsCode(key, void 0, "deleted");
		this._apiContextValues.delete(key);
	}
	appendSsoContext() {
		let replaceState = false;
		const params = new URLSearchParams(window.location.search);
		for (const [key, value] of [...params.entries()]) if (key.startsWith("sso_")) {
			const keyWithoutPrefix = key.slice(4);
			this.set(keyWithoutPrefix, value);
			this.setApiContextValue(keyWithoutPrefix, value);
			params.delete(key);
			replaceState = true;
		}
		if (replaceState) window.history.replaceState({}, "", params.size > 0 ? `?${params.toString()}` : "");
	}
	notifyVsCode(key, value, changeType) {
		postMessageToVsCode({
			command: "contextValueChanged",
			key,
			value,
			changeType
		});
	}
};
//#endregion
//#region src/context/applicationContextRegistry.ts
var registry$1 = createRegistry("Application context");
var registerApplicationContext = registry$1.register.bind(registry$1);
var getApplicationContext = registry$1.get.bind(registry$1);
//#endregion
//#region src/styleRules/StyleRuleContentDisplayMode.ts
var StyleRuleContentDisplayMode = /* @__PURE__ */ function(StyleRuleContentDisplayMode) {
	StyleRuleContentDisplayMode["iconBeforeText"] = "iconBeforeText";
	StyleRuleContentDisplayMode["iconAfterText"] = "iconAfterText";
	StyleRuleContentDisplayMode["icon"] = "icon";
	return StyleRuleContentDisplayMode;
}({});
//#endregion
//#region src/styleRules/StyleRule.ts
var StyleRule = class {
	constructor(options) {
		this.options = options;
	}
	evaluate(item, propertyName, result) {
		if (this.canEvaluateProperty(propertyName) && this.canEvaluateItem(item)) {
			this.apply(result);
			return true;
		}
		return false;
	}
	canEvaluateProperty(propertyName) {
		return this.options.propertyName == null || this.options.propertyName.toLowerCase() === propertyName.toLowerCase();
	}
	apply(result) {
		result.lightBackgroundColor ??= this.options.lightBackgroundColor;
		result.lightForegroundColor ??= this.options.lightForegroundColor;
		result.darkBackgroundColor ??= this.options.darkBackgroundColor;
		result.darkForegroundColor ??= this.options.darkForegroundColor;
		result.iconName ??= this.options.iconName;
		result.contentDisplayMode ??= this.options.contentDisplayMode;
		result.horizontalAlign ??= this.options.horizontalAlign;
		result.bold ??= this.options.bold;
		result.italic ??= this.options.italic;
		result.underline ??= this.options.underline;
		result.strikethrough ??= this.options.strikethrough;
		return result;
	}
};
//#endregion
//#region src/styleRules/UserStyleRule.ts
var UserStyleRule = class extends StyleRule {
	constructor(owner, options, applicationCondition) {
		super(options);
		this.owner = owner;
		this.applicationCondition = applicationCondition;
	}
	canEvaluateItem(item) {
		if (!this.applicationCondition) return true;
		return this.applicationCondition.evaluate([item], { viewModel: this.owner }).length > 0;
	}
};
//#endregion
//#region src/customUIView/CustomViewManager.ts
var CustomViewManager = class CustomViewManager {
	constructor(eventManager, globalResourceManager, apiClient) {
		this.customUIListViewApiPath = "CustomUIViewView";
		this.customUIDetailViewApiPath = "CustomUIViewDetailView";
		this.createUIViewName = "CustomUIViewCreateUI";
		this._defaultCustomViews = /* @__PURE__ */ new Map();
		this._customViews = /* @__PURE__ */ new Map();
		this._viewModelStates = /* @__PURE__ */ new Map();
		this._viewModelsToSort = [];
		this.eventManager = eventManager;
		this.globalResourceManager = globalResourceManager;
		this.apiClient = apiClient;
	}
	/**
	* Gets the customs views of the specified ui view.
	* @param uiViewName - The name of the ui view.
	*/
	getCustomViewsOfUIView(uiViewName) {
		return this._customViews.get(uiViewName) ?? [];
	}
	/**
	* Loads the customs view of the specified uiview for authenticated user.
	* @param owner - The view model from which the custom view is created.
	* @returns
	*/
	async loadCustomViewsAsync(owner) {
		const result = await this.apiClient.getAllAsync({
			path: this.customUIListViewApiPath,
			filter: Filter.create("uiViewName", FilterOperator.equal, owner.uiViewName).toODataString(),
			pageNumber: 0,
			recordsByPage: 500,
			sorts: [new Sort(`Name/${owner.localizator.currentLanguage}`, SortDirection.asc)]
		});
		if (!result.succeeded) {
			owner.showApiError(result.error);
			return [];
		}
		return result.data ?? [];
	}
	/**
	* Gets the custom views of the specified uiview for authenticated user.
	* @param owner - The view model from which the custom view is created.
	* @returns
	*/
	async getCustomViewsAsync(owner) {
		let customViews = this._customViews.get(owner.uiViewName);
		if (!customViews) {
			customViews = await this.loadCustomViewsAsync(owner);
			this._customViews.set(owner.uiViewName, customViews);
		}
		return customViews;
	}
	/**
	* Creates a new custom view.
	* @param owner - The view model from which the custom view is created.
	*
	*/
	async addCustomViewAsync(owner) {
		return new Promise((resolve, reject) => {
			owner.navigateAsync(new NavigationOptions(this.createUIViewName).withCreationMode(true).withParameter("OwnerViewModel", owner).onTarget(NavigationTarget.popup).withPopupSize(PopupSize.auto).withCallback((r) => {
				if (r.state === NavigationResultState.ok) {
					const newCustomView = this.cleanCustomViewModel(r.value);
					this.getCustomViewsOfUIView(owner.uiViewName).push(newCustomView);
					this.selectCustomViewAsync(owner, newCustomView);
					this.updateDefaultCustomView(newCustomView);
					resolve(newCustomView);
				} else resolve(void 0);
			})).catch(reject);
		});
	}
	/**
	* Edits the specified custom view.
	* @param owner - The view model from which the custom view has been created.
	* @param customView - The custom view to edit.
	* @param isSelected - A value indicating whether the custom view is selected.
	* @param autoSaveCallback - The callback to be invoked after auto-saving.
	* @returns
	*/
	async editCustomViewAsync(owner, customView, isSelected, autoSaveCallback) {
		const navigOptions = new NavigationOptions(this.createUIViewName).withId(new Map([["Id", customView.id]])).withParameter("OwnerViewModel", owner).withParameter("IsSelected", isSelected).withParameter("AutoSave", !!autoSaveCallback).onTarget(autoSaveCallback ? NavigationTarget.background : NavigationTarget.popup).withPopupSize(PopupSize.auto).withCallback((r) => {
			if (r.state === NavigationResultState.ok) {
				const newCustomView = this.cleanCustomViewModel(r.value);
				this.updateCustomViewInCache(newCustomView);
				this.selectCustomViewAsync(owner, newCustomView);
				this.updateDefaultCustomView(newCustomView);
			}
			autoSaveCallback?.();
		});
		return owner.navigateAsync(navigOptions);
	}
	/**
	* Selects the specified custom view (or restores the original one if customView parameter is undefined).
	* @param owner - The view model from which the custom view has been created.
	* @param customView - The custom view to select.
	* @param refresh - (OPTIONAL) Forces the refresh or the absence of refresh. Leave it undefined to let the method decide.
	* @returns
	*/
	async selectCustomViewAsync(owner, customView, refresh) {
		this._viewModelsToSort = [];
		owner.currentCustomViewId = customView?.id;
		let refreshNeeded = false;
		try {
			refreshNeeded = customView ? await this.applyCustomView(owner, customView) : this.restoreOriginalViewModelState(owner);
		} catch (error) {
			if (customView) {
				owner.currentCustomViewId = void 0;
				this.restoreOriginalViewModelState(owner);
			} else throw error;
		}
		refresh ??= refreshNeeded;
		if (refresh && !owner.hasChanges) await owner.checkAndLoadDataAsync();
		for (const viewModel of this._viewModelsToSort) viewModel.sortAsync();
		this.eventManager.emit("customview:changed", owner);
	}
	async applyCustomView(owner, customView) {
		try {
			let refreshNeeded = false;
			await this.loadCollectionsAsync(owner, customView);
			this.applyDisplayFilters(customView, owner);
			if (customView.dataFilter) {
				owner.setFilter(await owner.convertFilterFromJsonAsync(customView.dataFilter));
				refreshNeeded = true;
			} else if (!owner.dataFilter.isEmpty) {
				owner.setFilter(new Filter());
				refreshNeeded = true;
			}
			if (this.applyGroups(customView, owner)) refreshNeeded = true;
			if (this.applySorts(customView, owner)) refreshNeeded = true;
			this.applyProperties(customView, owner);
			await this.applyStyleRules(customView, owner);
			if (this.applyEntityViewParameters(customView, owner)) refreshNeeded = true;
			await this.applySubUIViews(customView, owner);
			return refreshNeeded;
		} catch (error) {
			const viewModelError = new ViewModelError(owner.globalResourceManager.get("CustomViewApplyErrorTitle"), stringFormat(owner.globalResourceManager.get("CustomViewApplyError"), owner.localizator.translate(customView.name)));
			viewModelError.errors = [error.message];
			owner.showError(viewModelError);
			throw error;
		}
	}
	applyDisplayFilters(customView, owner) {
		customView.dataFilterList ??= [];
		for (const filterAttribute of customView.dataFilterList) {
			const property = owner.findProperty(filterAttribute.name);
			if (property) {
				property.filterVisible = filterAttribute.visible;
				property.filterVisibleInPanel = filterAttribute.panelVisible;
				property.filterPosition = filterAttribute.position;
				property.filterComponent = moduleFilterComponentToCoreFilterComponentView(filterAttribute.component);
				const filterOperatorFromCustomView = moduleFilterOperatorToCoreFilterOperator(filterAttribute.defaultOperator);
				if (filterOperatorFromCustomView) property.filterDefaultOperator = filterOperatorFromCustomView;
			}
		}
	}
	applyGroups(customView, owner) {
		const previousGroupDescriptions = owner.groupDescriptions;
		owner.groupDescriptions = customView.dataGroups?.split(",").map((group) => {
			const propertyName = group.trim();
			return owner.findProperty(propertyName)?.camelCaseName;
		}).filter((group) => group !== void 0) ?? [];
		return !compareArray(previousGroupDescriptions, owner.groupDescriptions);
	}
	applySorts(customView, owner) {
		const previousDataSorts = owner.dataSorts;
		owner.dataSorts = customView.dataSorts?.split(",").map((sort) => {
			const [propertyName, directionName] = sort.trim().split(" ");
			const property = owner.findProperty(propertyName);
			const direction = directionName === "asc" ? SortDirection.asc : SortDirection.desc;
			return property ? new Sort(property.camelCaseName, direction) : void 0;
		}).filter((sort) => sort !== void 0) ?? [];
		if (!compareArray(previousDataSorts, owner.dataSorts)) {
			if (owner.parentRelation?.embeddedForReading) this._viewModelsToSort.push(owner);
			return true;
		}
		return false;
	}
	applyProperties(customView, owner) {
		customView.propertyList ??= [];
		for (const cvProp of customView.propertyList) {
			const property = owner.findProperty(cvProp.name);
			if (!property) continue;
			this.applyProperty(property, cvProp, owner);
		}
	}
	applyProperty(property, cvProp, owner) {
		property.datagridVisible = cvProp.datagridVisible;
		property.datagridPosition = cvProp.datagridPosition;
		property.datagridFrozen = cvProp.datagridFrozen;
		property.datagridMovable = cvProp.datagridMovable;
		property.datagridCaption = owner.localizator.translateLocalizableDefinedString(cvProp.datagridCaption ?? {});
		property.datagridWidth = cvProp.datagridColumnWidth == null ? void 0 : cvProp.datagridColumnWidth.toString();
		property.caption = owner.localizator.translateLocalizableDefinedString(cvProp.caption ?? {});
		property.ellipsis = cvProp.ellipsis;
		const horizontalAlign = CustomViewManager.convertContentAlign(cvProp.horizontalAlign);
		if (horizontalAlign) property.horizontalAlign = horizontalAlign;
		if (!owner.getProperty(cvProp.name).isReadOnlyExpression()) property.setReadOnly(cvProp.readonly);
		if (!owner.getProperty(cvProp.name).isRequiredExpression()) property.setRequired(cvProp.required);
		if (!owner.getProperty(cvProp.name).isFormVisibleExpression()) property.setFormVisible(cvProp.formVisible);
		if (!owner.getProperty(cvProp.name).isTabStopExpression()) property.setTabStop(cvProp.tabStop);
	}
	async applyStyleRules(customView, owner) {
		customView.styleRuleList ??= [];
		owner.userStyleRules = await Promise.all(customView.styleRuleList.filter((options) => options.enabled).sort((a, b) => b.executionOrder - a.executionOrder).map(async (options) => new UserStyleRule(owner, {
			...options,
			contentDisplayMode: CustomViewManager.convertStyleRuleContentDisplayMode(options.contentDisplayMode),
			horizontalAlign: CustomViewManager.convertContentAlign(options.horizontalAlign)
		}, options.applicationCondition ? await owner.convertFilterFromJsonAsync(options.applicationCondition) : null)));
	}
	applyEntityViewParameters(customView, owner) {
		let refresh = false;
		customView.entityViewParameterList ??= [];
		for (const parameter of customView.entityViewParameterList) {
			const viewModelParameter = owner.entityViewParameters.find((p) => p.name === parameter.name);
			if (viewModelParameter instanceof ViewModelEntityViewParameter && viewModelParameter.saveInCustomView && this.applyEntityViewParameter(parameter, viewModelParameter)) refresh = true;
		}
		return refresh;
	}
	applyEntityViewParameter(parameter, viewModelParameter) {
		let newValue = parameter.value;
		if (parameter.value != null) try {
			newValue = JSON.parse(parameter.value, defaultJsonReviver);
		} catch (error) {
			console.warn("Invalid entity view parameter value", {
				name: parameter.name,
				value: parameter.value,
				error
			});
			return false;
		}
		if (viewModelParameter.value === newValue) return false;
		viewModelParameter.value = newValue;
		return true;
	}
	async applySubUIViews(customView, owner) {
		customView.subUIViewList ??= [];
		for (const cvSubUIView of customView.subUIViewList) {
			if (!cvSubUIView.parentCollectionName) continue;
			const subUIView = owner.findSubViewModel(cvSubUIView.parentCollectionName);
			if (!subUIView) continue;
			this.applySorts(cvSubUIView, subUIView);
			this.applyProperties(cvSubUIView, subUIView);
			await this.applyStyleRules(cvSubUIView, subUIView);
			this.applyEntityViewParameters(cvSubUIView, subUIView);
			this.applySubUIViews(cvSubUIView, subUIView);
		}
	}
	/**
	* Deletes the specified custom view.
	* @param customViewId - the custom view identifier.
	*/
	async deleteCustomViewAsync(owner, customView) {
		const text = stringFormat(owner.globalResourceManager.get("RemoveCustomViewConfirmationText"), owner.localizator.translateLocalizableString(customView.name));
		if (!await this.confirmCustomViewDeletionAsync(owner, text)) return false;
		if (!await this.deleteCustomViewByIdAsync(owner, customView.id)) return false;
		const customViews = this.getCustomViewsOfUIView(owner.uiViewName);
		const index = customViews.findIndex((cv) => cv.id === customView.id);
		customViews.splice(index, 1);
		return true;
	}
	async deleteAutoCustomViewAsync(owner, customViewId) {
		const text = owner.globalResourceManager.get("RemoveAutoCustomViewConfirmationText");
		return await this.confirmCustomViewDeletionAsync(owner, text) && await this.deleteCustomViewByIdAsync(owner, customViewId);
	}
	async confirmCustomViewDeletionAsync(owner, text) {
		return (await owner.showMessageAsync(ViewModelMessageType.danger, owner.globalResourceManager.get("RemoveCustomView"), text, new ViewModelMessageButton(ViewModelMessageButtonType.yes, void 0, owner.globalResourceManager.get("RemoveConfirmationYesText"), "remove"), new ViewModelMessageButton(ViewModelMessageButtonType.no, void 0, owner.globalResourceManager.get("RemoveConfirmationNoText"), "close"))).buttonType === ViewModelMessageButtonType.yes;
	}
	async deleteCustomViewByIdAsync(owner, customViewId) {
		const apiResponse = await this.apiClient.deleteAsync({
			path: this.customUIListViewApiPath,
			id: customViewId
		});
		if (!apiResponse.succeeded) {
			owner.showApiError(apiResponse.error);
			return false;
		}
		return true;
	}
	/**
	* Save the current view model state.
	* @param owner - the view model.
	*/
	saveViewModelState(owner) {
		const viewModelState = this.getViewModelState(owner);
		this._viewModelStates.set(owner, viewModelState);
		for (const subView of owner.subViews) {
			const subUIViewState = this.getViewModelState(subView);
			viewModelState.subUIViews.set(subView.parentRelation.name, subUIViewState);
		}
	}
	getOriginalViewModelState(owner) {
		return this._viewModelStates.get(owner);
	}
	getCurrentViewConfiguration(owner) {
		return {
			uiViewName: owner.uiViewName,
			...this.createViewConfigurationBase(owner),
			subUIViewList: Array.from(owner.subViews, (subView) => this.createSubViewConfiguration(subView))
		};
	}
	async applyCurrentViewConfigurationAsync(owner, configuration, refresh) {
		this._viewModelsToSort = [];
		const refreshNeeded = await this.applyCustomView(owner, this.createCustomViewFromConfiguration(owner, configuration));
		refresh ??= refreshNeeded;
		if (refresh && !owner.hasChanges) await owner.checkAndLoadDataAsync();
		for (const viewModel of this._viewModelsToSort) viewModel.sortAsync();
		this.eventManager.emit("customview:changed", owner);
	}
	getViewModelState(owner) {
		return {
			filter: owner.dataFilter.clone(),
			groupDescriptions: [...owner.groupDescriptions],
			sorts: [...owner.dataSorts],
			properties: this.getPropertiesToSave(owner).map((p) => {
				const property = {
					name: p.name,
					datagridVisible: p.datagridVisible,
					datagridPosition: p.datagridPosition,
					datagridWidth: p.datagridWidth,
					datagridCaption: p.datagridCaption,
					datagridFrozen: p.datagridFrozen,
					datagridMovable: p.datagridMovable,
					filterVisible: p.filterVisible,
					filterVisibleInPanel: p.filterVisibleInPanel,
					filterComponent: p.filterComponent,
					filterPosition: p.filterPosition,
					caption: p.caption,
					ellipsis: p.ellipsis,
					horizontalAlign: p.horizontalAlign
				};
				if (!p.isReadOnlyExpression()) property.readonly = p.getReadOnly(void 0);
				if (!p.isRequiredExpression()) property.required = p.getRequired(void 0);
				if (!p.isFormVisibleExpression()) property.formVisible = p.getFormVisible(void 0);
				if (!p.isTabStopExpression()) property.tabStop = p.getTabStop(void 0);
				return property;
			}),
			entityViewParameters: owner.entityViewParameters.getValues((p) => p.saveInCustomView),
			subUIViews: /* @__PURE__ */ new Map()
		};
	}
	async loadCollectionsAsync(owner, customView) {
		if (!customView.dataFilterList) {
			const result = await this.apiClient.getAsync({
				path: this.customUIDetailViewApiPath,
				id: customView.id
			});
			if (!result.succeeded) {
				owner.showApiError(result.error);
				return;
			}
			customView.dataFilterList = result.data.dataFilterList;
			customView.propertyList = result.data.propertyList;
			customView.styleRuleList = result.data.styleRuleList;
			customView.entityViewParameterList = result.data.entityViewParameterList;
			customView.subUIViewList = result.data.subUIViewList;
		}
	}
	restoreOriginalViewModelState(owner) {
		const viewModelState = this.getOriginalViewModelState(owner);
		if (!viewModelState) return false;
		return this.setViewModelState(owner, viewModelState);
	}
	setViewModelState(owner, viewModelState) {
		owner.setFilter(viewModelState.filter);
		owner.groupDescriptions = viewModelState.groupDescriptions;
		owner.clearSort();
		viewModelState.sorts.forEach((sort) => {
			owner.setSort(sort.propertyName, sort.direction);
		});
		this.setPropertyViewModelState(owner, viewModelState);
		owner.userStyleRules.length = 0;
		owner.entityViewParameters.setValues(viewModelState.entityViewParameters);
		this.setSubViewModelState(owner, viewModelState);
		return true;
	}
	setSubViewModelState(owner, viewModelState) {
		for (const subView of owner.subViews) {
			const subUIViewState = viewModelState.subUIViews.get(subView.parentRelation.name);
			if (subUIViewState) this.setViewModelState(subView, subUIViewState);
		}
	}
	setPropertyViewModelState(owner, viewModelState) {
		for (const property of this.getPropertiesToSave(owner)) {
			const state = viewModelState.properties.find((p) => p.name === property.name);
			if (!state) continue;
			this.setPropertyViewModelStateByProperty(property, state);
		}
	}
	getPropertiesToSave(owner) {
		return owner.getProperties().filter((p) => p.displayable || p.filterOnly);
	}
	setPropertyViewModelStateByProperty(property, state) {
		property.datagridVisible = state.datagridVisible;
		property.datagridPosition = state.datagridPosition;
		property.datagridFrozen = state.datagridFrozen;
		property.datagridMovable = state.datagridMovable;
		property.datagridWidth = state.datagridWidth;
		property.datagridCaption = state.datagridCaption;
		property.filterVisible = state.filterVisible;
		property.filterVisibleInPanel = state.filterVisibleInPanel;
		property.filterComponent = state.filterComponent;
		property.filterPosition = state.filterPosition;
		property.caption = state.caption;
		property.ellipsis = state.ellipsis;
		property.horizontalAlign = state.horizontalAlign;
		if (!property.isReadOnlyExpression() && state.readonly !== void 0) property.setReadOnly(state.readonly);
		if (!property.isRequiredExpression() && state.required !== void 0) property.setRequired(state.required);
		if (!property.isFormVisibleExpression() && state.formVisible !== void 0) property.setFormVisible(state.formVisible);
		if (!property.isTabStopExpression() && state.tabStop !== void 0) property.setTabStop(state.tabStop);
	}
	cleanCustomViewModel(value) {
		return value.toRaw();
	}
	createViewConfigurationBase(owner) {
		return {
			dataFilter: owner.dataFilter.isEmpty ? null : owner.dataFilter.convertToJSON(),
			dataGroups: owner.groupDescriptions.length > 0 ? owner.groupDescriptions.join(",") : null,
			dataSorts: owner.dataSorts.length > 0 ? owner.dataSorts.map((sort) => sort.toString()).join(",") : null,
			dataFilterList: this.createDataFilterConfiguration(owner),
			propertyList: this.createPropertyConfiguration(owner),
			styleRuleList: this.createStyleRuleConfiguration(owner),
			entityViewParameterList: this.createEntityViewParameterConfiguration(owner)
		};
	}
	createSubViewConfiguration(owner) {
		return {
			parentCollectionName: owner.parentRelation?.name,
			dataSorts: owner.dataSorts.length > 0 ? owner.dataSorts.map((sort) => sort.toString()).join(",") : null,
			propertyList: this.createPropertyConfiguration(owner),
			styleRuleList: this.createStyleRuleConfiguration(owner),
			subUIViewList: Array.from(owner.subViews, (subView) => this.createSubViewConfiguration(subView))
		};
	}
	createDataFilterConfiguration(owner) {
		return this.getPropertiesToSave(owner).map((property, index) => ({
			id: index,
			name: property.name,
			visible: property.filterVisible,
			panelVisible: property.filterVisibleInPanel,
			position: property.filterPosition,
			defaultOperator: coreFilterOperatorToModuleFilterOperator(property.filterDefaultOperator),
			component: CustomViewManager.convertFilterComponentToModule(property.filterComponent)
		}));
	}
	createPropertyConfiguration(owner) {
		return this.getPropertiesToSave(owner).map((property, index) => ({
			id: index,
			name: property.name,
			caption: this.toLocalizableDefinedString(owner, property.caption),
			readonly: property.isReadOnlyExpression() ? property._readOnly ?? false : property.getReadOnly(void 0),
			required: property.isRequiredExpression() ? property._required ?? false : property.getRequired(void 0),
			datagridVisible: property.datagridVisible,
			datagridCaption: this.toLocalizableDefinedString(owner, property.datagridCaption),
			formVisible: property.isFormVisibleExpression() ? property._formVisible ?? true : property.getFormVisible(void 0),
			datagridPosition: property.datagridPosition,
			datagridFrozen: property.datagridFrozen,
			datagridMovable: property.datagridMovable,
			datagridColumnWidth: property.datagridWidth ?? null,
			tabStop: property.isTabStopExpression() ? property._tabStop ?? true : property.getTabStop(void 0),
			ellipsis: property.ellipsis,
			horizontalAlign: CustomViewManager.convertContentAlignToModule(property.horizontalAlign)
		}));
	}
	createStyleRuleConfiguration(owner) {
		return owner.userStyleRules.map((styleRule, index) => ({
			id: index,
			enabled: true,
			executionOrder: styleRule.options.executionOrder,
			propertyName: styleRule.options.propertyName,
			lightBackgroundColor: styleRule.options.lightBackgroundColor,
			lightForegroundColor: styleRule.options.lightForegroundColor,
			darkBackgroundColor: styleRule.options.darkBackgroundColor,
			darkForegroundColor: styleRule.options.darkForegroundColor,
			iconName: styleRule.options.iconName,
			contentDisplayMode: CustomViewManager.convertStyleRuleContentDisplayModeToModule(styleRule.options.contentDisplayMode),
			horizontalAlign: CustomViewManager.convertContentAlignToModule(styleRule.options.horizontalAlign),
			bold: styleRule.options.bold,
			italic: styleRule.options.italic,
			underline: styleRule.options.underline,
			strikethrough: styleRule.options.strikethrough,
			applicationCondition: styleRule.applicationCondition?.convertToJSON() ?? null
		}));
	}
	createEntityViewParameterConfiguration(owner) {
		return owner.entityViewParameters.filter((parameter) => parameter.saveInCustomView).map((parameter, index) => ({
			id: index,
			name: parameter.name,
			value: parameter.value == null ? null : JSON.stringify(parameter.value)
		}));
	}
	createCustomViewFromConfiguration(owner, configuration) {
		return {
			id: "ai-current-screen-configuration",
			name: { [owner.localizator.currentLanguage]: "AI current screen configuration" },
			uiViewName: configuration.uiViewName,
			userId: "",
			description: null,
			dataFilter: configuration.dataFilter ?? null,
			dataGroups: configuration.dataGroups ?? null,
			dataSorts: configuration.dataSorts ?? null,
			dataFilterList: configuration.dataFilterList ?? [],
			propertyList: configuration.propertyList ?? [],
			styleRuleList: configuration.styleRuleList ?? [],
			entityViewParameterList: configuration.entityViewParameterList ?? [],
			subUIViewList: configuration.subUIViewList ?? [],
			isDefault: false
		};
	}
	toLocalizableDefinedString(owner, value) {
		if (!value) return null;
		return { [owner.localizator.currentLanguage]: value };
	}
	getCustomView(uiViewName, customViewId) {
		return this.getCustomViewsOfUIView(uiViewName).find((cv) => cv.id === customViewId);
	}
	updateCustomViewInCache(customView) {
		const customViews = this.getCustomViewsOfUIView(customView.uiViewName);
		const index = customViews.findIndex((cv) => cv.id === customView.id);
		if (index !== -1) customViews[index] = customView;
	}
	updateDefaultCustomView(updatedCustomView) {
		if (updatedCustomView.isDefault) {
			this._defaultCustomViews.set(updatedCustomView.uiViewName, updatedCustomView.id);
			const customViews = this.getCustomViewsOfUIView(updatedCustomView.uiViewName);
			for (const customView of customViews) {
				if (customView.id === updatedCustomView.id) continue;
				customView.isDefault = false;
			}
		} else if (this._defaultCustomViews.get(updatedCustomView.uiViewName) === updatedCustomView.id) this._defaultCustomViews.delete(updatedCustomView.uiViewName);
	}
	initAsync(userCustomViewMode, userCanAssignDefaultCustomView) {
		this.userCustomViewMode = userCustomViewMode;
		this.userCanAssignDefaultCustomView = userCanAssignDefaultCustomView;
		if (this.userCustomViewMode) this._loadDefaultCustomViewsPromise = this.loadDefaultCustomViewsAsync();
		return this._loadDefaultCustomViewsPromise;
	}
	async loadDefaultCustomViewsAsync() {
		const apiResponse = await this.apiClient.getAllAsync({ path: "$neos/default-custom-views" });
		if (!apiResponse.succeeded) {
			this.eventManager.emit("viewModel:showError", ViewModelError.fromApiError(this.globalResourceManager, apiResponse.error));
			return;
		}
		for (const defaultCustomView of apiResponse.data) this._defaultCustomViews.set(defaultCustomView.uiViewName, defaultCustomView.customViewId);
	}
	/**
	* Gets the default custom view of an ui view
	* param uiViewName - The name of the ui view.
	*/
	async getDefaultCustomViewAsync(uiViewName) {
		await this._loadDefaultCustomViewsPromise;
		return this._defaultCustomViews.get(uiViewName);
	}
	/**
	* Sets the default custom view identifier of the specified ui view.
	*/
	async setDefaultCustomViewAsync(owner) {
		const customViewId = await this.getDefaultCustomViewAsync(owner.uiViewName);
		if (!customViewId) return false;
		const customView = (await this.getCustomViewsAsync(owner)).find((cv) => cv.id === customViewId);
		if (!customView) return false;
		await this.selectCustomViewAsync(owner, customView, false);
		return true;
	}
	async persistDefaultCustomViewAsync(uiViewName, customViewId) {
		const updatedCustomView = this.getCustomView(uiViewName, customViewId);
		if (updatedCustomView == null) return;
		const unset = updatedCustomView.isDefault;
		const apiResponse = await this.apiClient.postAsync({
			path: "$neos/set-default-custom-view",
			data: {
				uiViewName,
				defaultCustomViewId: customViewId,
				unset
			}
		});
		if (!apiResponse.succeeded) {
			this.eventManager.emit("viewModel:showError", ViewModelError.fromApiError(this.globalResourceManager, apiResponse.error));
			return;
		}
		updatedCustomView.isDefault = !unset;
		this.updateDefaultCustomView(updatedCustomView);
	}
	onCurrentCustomViewIdChanged(owner) {
		if (owner.initialized && this.userCustomViewMode === "Auto") {
			this._customViews.delete(owner.uiViewName);
			if (owner.currentCustomViewId) this._defaultCustomViews.set(owner.uiViewName, owner.currentCustomViewId);
			else this._defaultCustomViews.delete(owner.uiViewName);
		}
	}
	static convertContentAlign(value) {
		switch (value) {
			case "Start": return ContentAlign.start;
			case "Center": return ContentAlign.center;
			case "End": return ContentAlign.end;
			default: return null;
		}
	}
	static convertContentAlignToModule(value) {
		switch (value) {
			case ContentAlign.start: return "Start";
			case ContentAlign.center: return "Center";
			case ContentAlign.end: return "End";
			default: return null;
		}
	}
	static convertFilterComponentToModule(value) {
		switch (value) {
			case "calendarDay": return "CalendarDay";
			case "calendarMonth": return "CalendarMonth";
			case "calendarYear": return "CalendarYear";
			default: return null;
		}
	}
	static convertStyleRuleContentDisplayMode(value) {
		switch (value) {
			case "IconBeforeText": return StyleRuleContentDisplayMode.iconBeforeText;
			case "IconAfterText": return StyleRuleContentDisplayMode.iconAfterText;
			case "Icon": return StyleRuleContentDisplayMode.icon;
			default: return null;
		}
	}
	static convertStyleRuleContentDisplayModeToModule(value) {
		switch (value) {
			case StyleRuleContentDisplayMode.iconBeforeText: return "IconBeforeText";
			case StyleRuleContentDisplayMode.iconAfterText: return "IconAfterText";
			case StyleRuleContentDisplayMode.icon: return "Icon";
			default: return null;
		}
	}
};
//#endregion
//#region src/enums/createEnums.ts
/**
* Creates the object that contains all the enumeration types of the cluster.
* @param enums
* @returns
*/
function createEnums(enums) {
	return {
		...enums,
		/**
		* Finds an enumeration type by its name.
		* @param name  - Name of the enumeration.
		* @returns  The enumeration type if is has been found; otherwise `undefined`.
		*/
		findEnum: (name) => {
			return findEnum(enums, name);
		},
		/**
		* Gets an enumeration type by its name.
		* @param name - Name of the enumeration.
		* @returns The enumeration type.
		*/
		getEnum: (name) => {
			const enumType = findEnum(enums, name);
			if (enumType == null) throw new Error(stringFormat(getGlobalResourceManager(void 0).get("EnumDoesNotExist"), name));
			return enumType;
		}
	};
}
function findEnum(enums, name) {
	return enums[toCamelCase(name)];
}
//#endregion
//#region src/enums/EnumType.ts
function createEnumType(name, enumMembers) {
	const array = Object.values(enumMembers);
	return {
		...enumMembers,
		$name: name,
		getEnumMembers() {
			return array;
		},
		findEnumMember(name) {
			return array.find((x) => x.name === name);
		},
		getEnumMember(name) {
			const enumMember = this.findEnumMember(name);
			if (!enumMember) throw new Error(stringFormat(getGlobalResourceManager(void 0).get("EnumMemberDoesNotExist"), name));
			return enumMember;
		}
	};
}
var dataTypeEnumType;
function getDataTypeEnumType(clusterName) {
	if (!dataTypeEnumType) {
		const allowDataTypeDataType = getApplicationContext(clusterName).editedCluster?.name === "DesignerNeos";
		const enumMembers = {};
		const keys = Object.keys(DataType);
		for (const i of keys) {
			const name = DataType[i];
			enumMembers[i] = {
				name,
				caption: name,
				getEnabled() {
					return name !== "DataType" || allowDataTypeDataType;
				}
			};
		}
		dataTypeEnumType = createEnumType("DataType", enumMembers);
	}
	return dataTypeEnumType;
}
//#endregion
//#region src/exporting/CsvOptions.ts
/**
* Represents the CSV-specific options.
*/
var CsvOptions = class {
	/**
	* Sets the delimiter.
	* @param delimiter - The delimiter.
	* @returns The CSV-specific options.
	*/
	withDelimiter(delimiter) {
		this.delimiter = delimiter;
		return this;
	}
};
//#endregion
//#region src/filter/CustomFilterOperator.ts
var CustomFilterOperator = class {
	constructor(id, name, getFilterCondition) {
		this.id = id;
		this.name = name;
		this.getFilterCondition = async () => {
			const condition = await getFilterCondition();
			condition.customOperatorId = this.id;
			return condition;
		};
	}
};
//#endregion
//#region src/filter/NamedFilter.ts
var NamedFilter = class {
	constructor(id, name, getFilter) {
		this.id = id;
		this.name = name;
		this.getFilter = async () => {
			const filter = await getFilter();
			filter.namedFilterId = this.id;
			return filter;
		};
	}
};
//#endregion
//#region src/frames/Frame.ts
var Frame = class {
	/**
	* Gets the title.
	*/
	get title() {
		const navigationTitle = this._explicitTitle ?? this._menuBasedTitle;
		if (navigationTitle !== void 0) return navigationTitle;
		if (!this.viewModel) return "";
		try {
			const title = this.viewModel.title;
			this._titleError = void 0;
			return title;
		} catch (error) {
			const errorText = String(error);
			if (errorText !== this._titleError) {
				this._titleError = errorText;
				this.viewModel.showError({
					title: this.viewModel.globalResourceManager.get("TitleError"),
					text: this._titleError
				});
			}
			return `! ${this.uiViewName} !`;
		}
	}
	/**
	* Gets the explicit title.
	* (Needed by the router)
	*/
	get explicitTitle() {
		return this._explicitTitle;
	}
	/**
	* Gets the identifier of the menu-based navigation.
	* (Needed by the router)
	*/
	get menuItemName() {
		return this._menuItemName;
	}
	/**
	* Sets the title based on the caption of a menu-based navigation.
	* (Resolved from the `menuItemName` by the FrameManager)
	*/
	set menuBasedTitle(value) {
		this._menuBasedTitle = value;
	}
	/**
	* Gets the icon.
	*/
	get icon() {
		return this._icon ?? this.viewModel?.icon;
	}
	set icon(value) {
		this._icon = value;
	}
	/**
	* Gets a value indicating whether the view model has changes.
	*/
	get hasChanges() {
		return this.viewModel?.hasChanges === true;
	}
	constructor(options, displayMode) {
		this.guid = createGuid();
		this.uiViewName = options.uiViewName;
		this.remote = options.remote ?? options.callerRemote;
		this.id = options.frameId;
		this._explicitTitle = options.explicitTitle ?? void 0;
		this._menuItemName = options.menuItemName;
		this._icon = options.icon;
		this.parameters = options.parameters;
		this.frameUrlParameters = options.frameUrlParameters;
		this.closeable = options.closeable ?? true;
		this.closeableOnClickOutside = options.closeableOnClickOutside ?? false;
		this.ready = false;
		this.popupSize = options.popupSize;
		this.popupPosition = options.popupPosition ?? PopupPosition.center;
		this.popupMaximizable = options.popupMaximizable;
		this.datasource = options.datasource;
		this.filter = options.filter;
		this.position = options.position;
		this.callback = options.callback;
		this.itemAddedCallback = options.itemAddedCallback;
		this.dataSavedCallback = options.dataSavedCallback;
		this.displayMode = displayMode;
		this.navigationTarget = options.originalTarget ?? NavigationTarget.default;
	}
};
//#endregion
//#region src/globalSearch/GlobalSearchResultGroup.ts
var GlobalSearchResultGroup = class {
	constructor(caption, items) {
		this.caption = caption ?? null;
		this.items = items ?? [];
	}
};
//#endregion
//#region src/globalSearch/GlobalSearchResultItem.ts
var GlobalSearchResultItem = class {
	constructor(caption) {
		this.caption = caption;
	}
};
//#endregion
//#region src/globalSearch/getGlobalSearchFunction.ts
function getGlobalSearchFunction(allMenuItems, globalResourceManager, uiViewPermitter, onSearch) {
	const searchMenuItems = getArraySearchFunction(flatMenuItems(allMenuItems), { properties: { caption: {} } });
	async function search(text) {
		if (text.length === 0) return [];
		const result = [];
		const menuItemsGroup = convertMenuItemsToResultGroup(globalResourceManager, allMenuItems, searchMenuItems(text));
		if (menuItemsGroup) result.push(menuItemsGroup);
		const customItemsGroups = await searchCustomItems(text, uiViewPermitter, onSearch);
		result.push(...customItemsGroups);
		return result;
	}
	return search;
}
function flatMenuItems(menuItems) {
	function callback(menuItem) {
		const arr = [];
		if (menuItem.to || menuItem.code) arr.push(menuItem);
		if (menuItem.children) arr.push(...menuItem.children.flatMap(callback));
		return arr;
	}
	return menuItems.flatMap(callback);
}
function getParentMenuPath(allMenuItems, menuItem) {
	const parents = [];
	const parent = getMenuParent(allMenuItems, menuItem);
	if (parent) {
		parents.push(parent.caption);
		parents.push(...getParentMenuPath(allMenuItems, parent));
	}
	return parents;
}
function getMenuParent(menuItems, targetItem) {
	for (const item of menuItems) {
		if (!item.children) continue;
		if (item.children.includes(targetItem)) return item;
		const parent = getMenuParent(item.children, targetItem);
		if (parent) return parent;
	}
}
function convertMenuItemsToResultGroup(globalResourceManager, allMenuItems, menuItems) {
	const items = menuItems.map((i) => {
		const item = new GlobalSearchResultItem(i.caption);
		item.icon = i.icon;
		item.menuItem = i;
		item.description = getParentMenuPath(allMenuItems, i).reverse().join(" > ");
		return item;
	});
	if (items.length === 0) return;
	return new GlobalSearchResultGroup(items.length > 1 ? stringFormat(globalResourceManager.get("MenuItemsGroupCaption"), items.length) : globalResourceManager.get("MenuItemGroupCaption"), items);
}
async function searchCustomItems(text, uiViewPermitter, onSearch) {
	if (!onSearch) return [];
	const groups = await onSearch(text);
	for (const group of groups) {
		group.items = group.items.filter((i) => i.uiViewName && uiViewPermitter.canRead(i.uiViewName));
		for (const item of group.items) {
			if (item.itemId) item.itemId = new Map(Object.entries(item.itemId));
			if (item.parameters) item.parameters = new NavigationParameters(Object.entries(item.parameters));
		}
	}
	return groups.filter((g) => g.items.length > 0);
}
//#endregion
//#region src/permissions/uiViewPermitterRegistry.ts
var registry = createRegistry("UI view permitter");
var registerUIViewPermitter = registry.register.bind(registry);
var getUIViewPermitter = registry.get.bind(registry);
var findUIViewPermitter = registry.find.bind(registry);
//#endregion
//#region src/menu/MenuItem.ts
function getMenuItemDependencies(clusterName) {
	return {
		applicationContext: getApplicationContext(clusterName),
		eventManager: getEventManager(),
		globalResourceManager: getGlobalResourceManager(clusterName),
		apiClient: getApiClient(clusterName),
		uiViewPermitter: getUIViewPermitter(clusterName)
	};
}
function recursiveFindMenuItem(menuItems, menuItemName) {
	if (!menuItems || !menuItemName) return;
	for (const menuItem of menuItems) {
		if (menuItem.path === menuItemName || menuItem.path.endsWith(`/${menuItemName}`)) return menuItem;
		const childMenuItem = recursiveFindMenuItem(menuItem.children, menuItemName);
		if (childMenuItem !== void 0) return childMenuItem;
	}
}
/**
* Represents a menu item.
*/
var MenuItem = class {
	/**
	* Initializes a new instance of the MenuItem class.
	* @param dependencies - Dependencies.
	* @param path - Path leading to menu item from the root of the menu containing it.
	* @param caption - Caption.
	* @param icon - Icon name.
	* @param to - Name of the UI view that the menu item opens.
	* @param code - Code that the menu item executes.
	* @param children - Children.
	*/
	constructor(dependencies, path, caption, icon, to, code, children) {
		this.isBusy = false;
		this.expanded = false;
		this.dependencies = dependencies;
		this.path = path;
		this.caption = caption;
		this.icon = icon;
		this.to = to;
		this.code = code;
		this.children = children;
	}
	/**
	* Executes the action associated to menu item.
	*
	* @remarks - When menu item type is 'Open a view', the menu item identifier
	* (its name) is stored on the navigation options via the same mechanism than
	* the one performed by the router in case of a page refresh (after the URL is
	* parsed, when a navigation is triggered).
	*
	*
	* When the menu item type is 'Execute code', the menu item identifier (its
	* name) is stored in a global variable for the time of the execution of the
	* code and the navigation options (if any) are updated accordingly, at the
	* last moment, right before the 'navigate' event is emitted.
	*
	*/
	execute() {
		const menuItemName = this.path.substring(this.path.lastIndexOf("/") + 1);
		if (this.to !== void 0) {
			const navOptions = new NavigationOptions(this.to).withMenuItemName(menuItemName);
			this.navigateAsync(navOptions);
		}
		if (this.code !== void 0 && !this.isBusy) {
			this.isBusy = true;
			runWithGlobalMenuItemContext(menuItemName, () => {
				this.code().finally(() => {
					this.isBusy = false;
				});
			});
		}
	}
	/**
	* Navigates to a view.
	* @param options - Navigation options.
	*/
	navigateAsync(options) {
		navigate(this.dependencies.eventManager, options);
	}
	/**
	* Collapses the children and itself.
	*/
	collapse() {
		if (this.children) for (const child of this.children) child.collapse();
		this.expanded = false;
	}
	/**
	* Ask report generating in PDF.
	* @param options report options.
	* @returns Promise
	*/
	executeReportAsync(options) {
		return Reporting.executeReportAsync(options, {
			reportingBaseUrl: Reporting.getBaseUrl(),
			applicationContext: this.dependencies.applicationContext,
			eventManager: this.dependencies.eventManager,
			globalResourceManager: this.dependencies.globalResourceManager,
			uiViewPermitter: this.dependencies.uiViewPermitter,
			callingUIViewName: void 0
		});
	}
	/**
	* Show a report viewer in ReportViewerUI.
	* @param options report options.
	* @returns Promise
	*/
	async showReportAsync(options) {
		navigate(this.dependencies.eventManager, Reporting.getShowReportNavigationOptions(options));
	}
	/**
	* Triggers an event to display an error.
	*
	* @param error - Error.
	*/
	showError(error) {
		this.dependencies.eventManager.emit("viewModel:showError", error);
	}
	/**
	* Displays an API error.
	*/
	showApiError(err) {
		ApiErrorMessageOverrider.overrideMessage(this.dependencies.globalResourceManager, err, void 0);
		this.showError(ViewModelError.fromApiError(this.dependencies.globalResourceManager, err));
	}
	/**
	* Executes a server data export.
	* @param options - The options.
	*/
	async exportServerDataAsync(options) {
		const response = await this.dependencies.apiClient.postAsync({
			path: "$neos/exports/execute",
			data: {
				entityViewName: options.entityViewName,
				fileName: options.fileName,
				format: options.format,
				properties: options.properties,
				filter: options.filter,
				orderBy: options.orderBy,
				entityViewParameters: options.entityViewParameters,
				culture: options.culture
			}
		});
		if (!response.succeeded) this.showApiError(response.error);
	}
};
//#endregion
//#region src/notifications/Notification.ts
/**
* Notification.
*/
var Notification = class {
	/**
	* Initializes a new instance of the Notification class.
	* @param connection - Notification connection.
	* @param name - Notification name.
	*/
	constructor(connection, name) {
		this.connection = connection;
		this.name = name;
		this.handlers = [];
	}
	/**
	* Adds a handler that will be invoked when the notification is invoked.
	* @param handler - The handler to add.
	*/
	addHandler(handler) {
		this.connection.addHandler(this.name, handler);
		this.handlers.push(handler);
	}
	/**
	* Removes the specified handler.
	* @param handler - The handler to remove.
	*/
	removeHandler(handler) {
		const index = this.handlers.indexOf(handler);
		if (index !== -1) {
			this.connection.removeHandler(this.name, handler);
			this.handlers.splice(index, 1);
		}
	}
	/**
	* Clears the handlers.
	*/
	clearHandlers() {
		for (const handler of this.handlers) this.connection.removeHandler(this.name, handler);
		this.handlers.length = 0;
	}
};
//#endregion
//#region src/notifications/NotificationConnection.ts
/**
* Notification connection.
*/
var NotificationConnection = class {
	constructor(url) {
		this.reconnectedEvent = createLocalEvent();
		this.url = url;
	}
	get id() {
		if (!this._connection) return;
		return this._connection?.connectionId;
	}
	/**
	* Starts the connection.
	*/
	async startAsync(headers) {
		this._connection = new HubConnectionBuilder().withUrl(this.url, { headers }).withAutomaticReconnect({ nextRetryDelayInMilliseconds: () => 1e4 }).withHubProtocol(new CustomJsonHubProtocol()).configureLogging(LogLevel.Error).build();
		this._connection.onreconnected((connectionId) => {
			this.reconnectedEvent.raise(connectionId);
		});
		try {
			await this._connection.start();
		} catch (error) {
			console.error("Error while starting the notification connection:", error);
		}
	}
	/**
	* Stops the connection.
	*/
	async stopAsync() {
		if (this._connection) {
			await this._connection.stop();
			this._connection = void 0;
		}
	}
	/**
	* Adds a handler that will be invoked when the specified notification is invoked.
	* @param name - The name of the notification to define.
	* @param handler - The handler to add.
	*/
	addHandler(name, handler) {
		if (this._connection) this._connection.on(name, handler);
	}
	/**
	* Removes the specified handler for the specified notification.
	* @param notificationName - The name of the notification to remove handlers for.
	* @param handler - The handler to remove.
	*/
	removeHandler(name, handler) {
		if (this._connection) if (handler) this._connection.off(name, handler);
		else this._connection.off(name);
	}
	subscribeConnectionId(setter) {
		if (this.id) setter(this.id);
		const onReconnected = (connectionId) => setter(connectionId);
		this.reconnectedEvent.add(onReconnected);
		return () => this.reconnectedEvent.remove(onReconnected);
	}
};
var CustomJsonHubProtocol = class extends JsonHubProtocol {
	parseMessages(input, logger) {
		const originalJsonParse = JSON.parse;
		JSON.parse = (text) => originalJsonParse(text, defaultJsonReviver);
		const hubMessages = super.parseMessages(input, logger);
		JSON.parse = originalJsonParse;
		return hubMessages;
	}
};
//#endregion
//#region src/notifications/NotificationRegistry.ts
/**
* Notification registry.
*/
var NotificationRegistry = class {
	constructor(connection) {
		this.notifications = [];
		this.connection = connection;
	}
	/**
	* Creates the notification.
	* @param name - Notification name.
	* @returns Notification.
	*/
	create(name) {
		const notification = new Notification(this.connection, name);
		this.notifications.push(notification);
		return notification;
	}
	/**
	* Clears the handlers of all the notifications.
	*/
	clearHandlers() {
		for (const notification of this.notifications) notification.clearHandlers();
	}
};
//#endregion
//#region src/permissions/UIViewOperation.ts
var UIViewOperation = /* @__PURE__ */ function(UIViewOperation) {
	UIViewOperation["create"] = "C";
	UIViewOperation["read"] = "R";
	UIViewOperation["update"] = "U";
	UIViewOperation["delete"] = "D";
	return UIViewOperation;
}({});
//#endregion
//#region src/permissions/UIViewPermitter.ts
var UIViewPermitter = class {
	constructor(mainUIViewName, shouldLog) {
		this.mainUIViewName = mainUIViewName;
		this.shouldLog = shouldLog;
	}
	get permissions() {
		return this._permissions;
	}
	set permissions(value) {
		this._permissions = value ? {
			NeosReportViewerUI: { operations: "CRUD" },
			...value
		} : void 0;
	}
	canCreate(uiViewName) {
		if (!this.permissions) return true;
		if (this.permissions[uiViewName]?.operations.includes(UIViewOperation.create)) return true;
		this.log(`Create access denied for UI view: ${uiViewName}`);
		return false;
	}
	canRead(uiViewName) {
		if (!this.permissions) return true;
		if (this.permissions[uiViewName]?.operations.includes(UIViewOperation.read)) return true;
		this.log(`Read access denied for UI view: ${uiViewName}`);
		return false;
	}
	canUpdate(uiViewName) {
		if (!this.permissions) return true;
		if (this.permissions[uiViewName]?.operations.includes(UIViewOperation.update)) return true;
		this.log(`Update access denied for UI view: ${uiViewName}`);
		return false;
	}
	canDelete(uiViewName) {
		if (!this.permissions) return true;
		if (this.permissions[uiViewName]?.operations.includes(UIViewOperation.delete)) return true;
		this.log(`Delete access denied for UI view: ${uiViewName}`);
		return false;
	}
	canSave(uiViewName) {
		if (!this.permissions) return true;
		const uiViewPermission = this.permissions[uiViewName];
		if (uiViewPermission && (uiViewPermission.operations.includes(UIViewOperation.create) || uiViewPermission.operations.includes(UIViewOperation.update))) return true;
		this.log(`Save access denied for UI view: ${uiViewName}`);
		return false;
	}
	canExecuteAction(uiViewName, actionName) {
		if (!this.permissions) return true;
		const uiViewPermission = this.permissions[uiViewName];
		if (!uiViewPermission) {
			if (uiViewName === this.mainUIViewName) return true;
			this.log(`Action access denied for UI view action: ${uiViewName}.${actionName}`);
			return false;
		}
		if (uiViewPermission.disabledActions?.includes(actionName)) {
			this.log(`Action access denied for UI view action: ${uiViewName}.${actionName}`);
			return false;
		}
		return true;
	}
	canNavigate(options) {
		if (!this.permissions) return true;
		const operation = options.parameters.creationMode ? UIViewOperation.create : UIViewOperation.read;
		if (this.permissions[options.uiViewName]?.operations.includes(operation)) return true;
		this.log(`${operation === UIViewOperation.create ? "Create" : "Read"} access denied for UI view: ${options.uiViewName}`);
		return false;
	}
	/**
	* Gets the permissions of the specified UI view.
	* @param uiViewName - UI view name.
	* @returns Permissions.
	*/
	getPermissions(uiViewName) {
		return {
			canRead: () => this.canRead(uiViewName),
			canCreate: () => this.canCreate(uiViewName),
			canUpdate: () => this.canUpdate(uiViewName),
			canDelete: () => this.canDelete(uiViewName),
			canSave: () => this.canSave(uiViewName),
			canExecuteAction: (actionName) => this.canExecuteAction(uiViewName, actionName),
			canNavigate: (options) => this.canNavigate(options)
		};
	}
	log(message) {
		if (this.shouldLog) console.log(message);
	}
};
//#endregion
//#region src/reactivity/ReactiveDevice.ts
var reactiveDevice = void 0;
var ReactiveDevice = { get instance() {
	if (!reactiveDevice) {
		reactiveDevice = reactive(new Device());
		reactiveDevice.on();
	}
	return reactiveDevice;
} };
/********\
* EXPORT *
\********/
var reportEvents = {
	generationSucceeded: {
		...createLocalEvent(),
		async raiseWithNotificationArgsAsync(notificationArgs, baseUrl = getBaseUrl()) {
			const eventArgs = {
				generationIdentifier: notificationArgs.generationIdentifier,
				reportOptions: Reporting.popPendingReportOptions(notificationArgs.generationIdentifier),
				displayToast: true,
				fileIdentifier: notificationArgs.fileIdentifier,
				fileUrl: Reporting.getReportFileUrl(baseUrl, notificationArgs.generationIdentifier, notificationArgs.fileIdentifier, false)
			};
			await this.raiseSequentiallyAsync(eventArgs);
			return eventArgs;
		}
	},
	generationFailed: {
		...createLocalEvent(),
		async raiseWithNotificationArgsAsync(notificationArgs) {
			const eventArgs = {
				generationIdentifier: notificationArgs.generationIdentifier,
				reportOptions: Reporting.popPendingReportOptions(notificationArgs.generationIdentifier),
				displayToast: true,
				errorMessage: notificationArgs.errorMessage,
				errorDetails: notificationArgs.errorDetails
			};
			await this.raiseSequentiallyAsync(eventArgs);
			return eventArgs;
		}
	}
};
//#endregion
//#region src/reporting/options/ReportViewerMode.ts
/**
* Specifies the initial layout of the report viewer.
*/
var ReportViewerMode = /* @__PURE__ */ function(ReportViewerMode) {
	/**
	* Single page with "next" and "previous" navigation buttons.
	*/
	ReportViewerMode["singlePage"] = "singlePage";
	/**
	* All the pages shown vertically, one after the other.
	*/
	ReportViewerMode["continuous"] = "continuous";
	/**
	* All the pages shown as tiles (if there is enough horizontal space; falls back to Continuous mode otherwise).
	*/
	ReportViewerMode["multiplePages"] = "multiplePages";
	return ReportViewerMode;
}({});
//#endregion
//#region src/reporting/options/ReportViewerOptions.ts
/**
* Represents the options for ReportViewer.vue component,
* which is a different set of options than the ones provided to
* ShowReport which uses the native 'NeosReportViewerUI' UI View.
*/
var ReportViewerOptions = class extends AbstractReportOptions {
	/**
	* Initializes a new instance of the ReportViewerOptions class.
	* @param reportName - Report name.
	*/
	constructor(reportName) {
		super(reportName);
		this.initialViewerMode = void 0;
	}
	/**
	* Sets the initial view mode.
	* @param mode - initial view mode.
	*/
	withInitialViewerMode(mode) {
		this.initialViewerMode = mode;
		return this;
	}
	/**
	* Sets the remote.
	* @param remote - remote.
	*/
	withRemote(remote) {
		this.remote = remote;
		return this;
	}
};
//#endregion
//#region src/reporting/options/ShowReportOptions.ts
/**
* Represents the options for ShowReport function.
*/
var ShowReportOptions = class extends AbstractReportOptions {
	/**
	* Initializes a new instance of the ShowReportOptions class.
	* @param reportName - Report name.
	*/
	constructor(reportName, tabTitle) {
		super(reportName);
		this.title = tabTitle ?? reportName;
	}
	/**
	* Sets the title of the report.
	* @param title - title of the report.
	*/
	withTitle(title) {
		this.title = title;
		return this;
	}
	/**
	* Sets the initial view mode.
	* @param mode - initial view mode.
	*/
	withInitialViewerMode(mode) {
		this.initialViewerMode = mode;
		return this;
	}
	/**
	* Sets the remote.
	* @param remote - remote.
	*/
	withRemote(remote) {
		this.remote = remote;
		return this;
	}
};
//#endregion
//#region src/storage/LocalStorage.ts
function getGlobalLocalStorage() {
	return new LocalStorage();
}
function getClusterLocalStorage(clusterName) {
	return new LocalStorage(() => clusterName);
}
function getTenantLocalStorage(clusterName, tenantIdentifier) {
	return new LocalStorage(() => `${clusterName}_${tenantIdentifier}`);
}
var LocalStorage = class {
	constructor(getKeyPrefix) {
		this.getKeyPrefix = getKeyPrefix;
	}
	containsKey(key) {
		key = this.getFullKey(key);
		return localStorage.getItem(key) != null;
	}
	findValue(key, type) {
		key = this.getFullKey(key);
		const item = localStorage.getItem(key);
		if (item == null) return null;
		return type === "string" ? item : JSON.parse(item);
	}
	getValue(key, type, defaultValue) {
		const value = this.findValue(key, type);
		if (value == null) {
			if (defaultValue != null) return defaultValue;
			throw new Error(`Key ${key} not found`);
		}
		return value;
	}
	tryGetValue(key, result, type) {
		result.value = this.findValue(key, type);
		return result.value != null;
	}
	set(key, value) {
		key = this.getFullKey(key);
		localStorage.setItem(key, typeof value === "string" ? value : JSON.stringify(value));
	}
	remove(key) {
		key = this.getFullKey(key);
		localStorage.removeItem(key);
	}
	getFullKey(key) {
		if (!this.getKeyPrefix) return key;
		return `${this.getKeyPrefix()}_${key}`;
	}
};
//#endregion
//#region src/styleRules/DevStyleRule.ts
var DevStyleRule = class extends StyleRule {
	constructor(owner, options) {
		super(options);
		this.owner = owner;
	}
	canEvaluateItem(item) {
		return this.getApplicationCondition(item);
	}
};
//#endregion
//#region src/summaries/SummaryRequest.ts
var SummaryRequest = class {
	constructor(property, summaryType) {
		this.property = property;
		this.summaryType = summaryType;
	}
};
//#endregion
//#region src/viewModel/NestedViewModel.ts
var positionFieldName = `_position`;
var propertiesToReadOnNestedViewModel = new Set([
	positionFieldName,
	`id`,
	`actions`,
	`computeds`,
	`computedChangedEvent`,
	`methods`,
	`onPositionChanging`,
	`onPositionChanged`,
	`onItemAdding`,
	`onItemAdded`,
	`onItemSelectionChanging`,
	`onItemSelectionChanged`,
	`onRemoving`,
	`onItemRemoving`,
	`onItemRemoved`,
	`referenceRetrievingEventRules`,
	`referenceSelectedEventRules`,
	`lastAddedItem`,
	`isAddingAddNewItem`,
	`addNewItem`,
	`datasourceListChangedEvent`
]);
var NestedViewModel = class NestedViewModel {
	/**
	* Creates a nested view model.
	* @param options - Options.
	* @param parentViewModel - The parent view model when the nested view model is based on sub view model.
	* @param computedViewModel - The view model that owns the computed that provides the data for the nested view model.
	* @param originalViewModel - The view model on which the nested view model is based.
	* @param instantiateViewModel - The method to instantiate the nested view model.
	* @param computedName - The computed name.
	* @param computedValue - The method to evaluate the computed.
	* @returns
	*/
	static create(options, parentViewModel, computedViewModel, originalViewModel, instantiateViewModel, computedName, computedValue) {
		if (!options.rootViewModel) throw new Error(options.globalResourceManager.get("NestedViewModelMustHaveRoot"));
		const wrapInstance = options.wrapInstance ?? ((instance) => instance);
		const nestedDataSource = wrapInstance(new ObservableList(...computedValue(computedViewModel)));
		nestedDataSource.setOwner(originalViewModel.datasource.owner, originalViewModel.datasource.ownerNavigationPropertyName);
		const nestedViewModel = instantiateViewModel({
			...options,
			wrapInstance(instance) {
				return new Proxy(wrapInstance(instance), {
					get(target, property, receiver) {
						if (property === `datasource` || property === `_datasource`) return nestedDataSource;
						if (property === `fullDatasource`) return originalViewModel.fullDatasource;
						if (property === `originalViewModel`) return originalViewModel;
						if (property === `parentViewModel` && parentViewModel) return parentViewModel;
						if (propertiesToReadOnNestedViewModel.has(property)) return Reflect.get(target, property, receiver);
						return Reflect.get(originalViewModel, property, receiver);
					},
					set(target, property, value, receiver) {
						if (property === positionFieldName) {
							const res = Reflect.set(target, property, value, receiver);
							NestedViewModel.updateOriginalViewModelPosition(parentViewModel, originalViewModel, nestedViewModel);
							return res;
						}
						return Reflect.set(originalViewModel, property, value, receiver);
					}
				});
			}
		});
		computedViewModel.computedChangedEvent.add((name) => {
			this.computedChangedHandler(name, computedViewModel, originalViewModel, nestedViewModel, computedName, computedValue);
		});
		return nestedViewModel;
	}
	static computedChangedHandler(name, computedViewModel, originalViewModel, nestedViewModel, computedName, computedValue) {
		if (name === computedName) {
			nestedViewModel.datasource.setOwner(originalViewModel.datasource.owner, originalViewModel.datasource.ownerNavigationPropertyName);
			nestedViewModel.datasource.setItems(computedValue(computedViewModel));
			nestedViewModel.ensurePositionIsValid();
		}
	}
	static updateOriginalViewModelPosition(parentViewModel, originalViewModel, nestedViewModel) {
		originalViewModel.position = nestedViewModel.current ? originalViewModel.datasource.indexOf(nestedViewModel.current) : -1;
	}
};
//#endregion
//#region src/viewModel/SubViews.ts
function createSubViews() {
	const subViewModels = [];
	return {
		get length() {
			return subViewModels.length;
		},
		add(name, viewModel) {
			this[name] = viewModel;
			subViewModels.push(viewModel);
		},
		find(predicate) {
			return subViewModels.find(predicate);
		},
		some(predicate) {
			return subViewModels.some(predicate);
		},
		forEach(callbackfn) {
			return subViewModels.forEach(callbackfn);
		},
		[Symbol.iterator]() {
			let index = -1;
			return { next() {
				index++;
				return index >= subViewModels.length ? {
					value: void 0,
					done: true
				} : {
					value: subViewModels[index],
					done: false
				};
			} };
		}
	};
}
//#endregion
//#region src/viewModel/ViewModelComputed.ts
var ViewModelComputed = class {
	/**
	* Initialize a new ViewModelComputed instance.
	*
	* @param owner - ViewModel owner.
	*/
	constructor(owner) {
		this.owner = owner;
	}
};
//#endregion
//#region src/viewModel/ViewModelRelation.ts
/**
* Gets the relationship caption defined in entityView for embedded relationship or the sub ui view title for non embedded relationship.
* param viewModel - View model owner of the relationship.
* param relationName - Name of the relationship.
*/
function getRelationshipCaption(viewModel, relationship) {
	return viewModel.resourceManager.find(`relationships.${relationship.name.replaceAll(".", "_")}.caption`) ?? viewModel.getSubViewModel(relationship.name).title ?? relationship.name;
}
//#endregion
//#region src/viewModelToast/ViewModelToastButton.ts
/**
* View model message button.
*/
var ViewModelToastButton = class {
	constructor(text, icon, action) {
		this.action = action;
		this.icon = icon;
		this.text = text;
	}
};
//#endregion
//#region src/vsCodeExt/vsCode.ts
/**
* VSCode extension integration functions
* This module is only loaded when __NEOS_STUDIO_VSCODE__ is true
*/
var _assetsBaseUrl;
var _theme;
/** initialize VsCode options from context.
* base url, assets base url, auth token, view type and theme.
*/
function initVsCodeOptions() {
	const vsCodeContext = getVsCodeContext();
	if (!vsCodeContext) throw new Error("VSCode context is not available.");
	setAssetsBaseUrl(vsCodeContext.assetsBaseUrl);
	setBaseUrl(vsCodeContext.baseUrl);
	setViewType(vsCodeContext.viewType);
	setTheme(vsCodeContext.theme);
}
/** Initialize Monaco Editor for VSCode extension
* getWorker should be set to load workers from VSCode extension assets
*/
async function initMonacoForVsCodeAsync() {
	const getTasks = [];
	getTasks.push(getUrlWorker("editor.worker.js", "editor"), getUrlWorker("ts.worker.js", "typescript"), getUrlWorker("yaml.worker.js", "yaml"));
	return Promise.all(getTasks).then((values) => {
		window.MonacoEnvironment = { getWorker: (_workerId, label) => {
			if (label === "typescript" || label === "javascript") return new Worker(values.find((v) => v.label === "typescript").url);
			if (label === "yaml") return new Worker(values.find((v) => v.label === "yaml").url);
			return new Worker(values.find((v) => v.label === "editor").url);
		} };
	});
}
/** Provide Vue app with VsCode context values */
async function provideForVsCode(app) {
	const vsCodeContext = getVsCodeContext();
	app.provide("mainUIViewName", vsCodeContext?.mainUIViewName);
	if (vsCodeContext?.navigationOptions) app.provide("initialNavigationOptions", await NavigationOptions.fromObject(vsCodeContext.navigationOptions));
}
/** Gets the current theme for VSCode extension */
function getThemeForVsCode() {
	return _theme;
}
async function getUrlWorker(workerSource, label) {
	const blob = await (await fetch(getVsCodeAssetUri(workerSource))).blob();
	return {
		label,
		url: URL.createObjectURL(blob)
	};
}
function getVsCodeContext() {
	return globalThis.vsCodeContext;
}
function setAssetsBaseUrl(value) {
	_assetsBaseUrl = value;
}
function getVsCodeAssetUri(path) {
	return _assetsBaseUrl + path;
}
function setTheme(value) {
	_theme = value;
}
//#endregion
export { ApiParameterBinding, ApplicationContext, BaseComponentViewModel, BaseSort, ComponentViewModel, ComponentViewModelComputed, ComponentViewModelParameters, ConstraintValidationMessage, ContentAlign, CsvOptions, CustomFilterOperator, CustomJsonHubProtocol, CustomViewManager, DeletionMode, DevStyleRule, ExecuteReportOptions, ExportFormat, ExpressionSort, FetchApiClient, FetchError, FileReference, FileUploadState, Filter, FilterComponent, FilterCondition, FilterFunction, FilterLogicalOperator, FilterOperation, FilterOperator, FilterValue, FilteringExecutionSide, Frame, FrameDisplayMode, GlobalSearchResultGroup, GlobalSearchResultItem, Group, GroupDescription, GroupList, GroupSummaryResult, GroupingExecutionSide, ListChangedType, ListLoadingState, LookupMainMode, LookupSearchMode, LookupTemplateMode, MenuItem, Model, NamedFilter, NavigationOptions, NavigationParameters, NavigationResult, NavigationResultState, NavigationResultWithoutValue, NavigationTarget, NestedViewModel, Notification, NotificationConnection, NotificationRegistry, ObservableList, PrivateBaseReportOptions, ReactiveDevice, ReferenceRetrievingTrigger, RelationType, ReportViewerMode, ReportViewerOptions, Reporting, ServerDataExportOptions, ServerGroup, ServerMethodError, ShowReportOptions, Sort, SortDirection, SortingExecutionSide, StatusFilterMode, StyleRule, StyleRuleContentDisplayMode, SummaryDescription, SummaryRequest, SummaryResult, ToggleOverlayOptions, UIViewOperation, UIViewPermitter, UserStyleRule, ValidationMessage, ValidationRuleSeverityLevel, ValidationRuleValidationMessage, ValidationRuleValidationTypes, ViewModel, ViewModelActionBadgeSeverity, ViewModelActionBase, ViewModelActionConstraint, ViewModelActionDisplayMode, ViewModelActionLocation, ViewModelActionLocationEntry, ViewModelActionSize, ViewModelActionStyle, ViewModelActionType, ViewModelActions, ViewModelComputed, ViewModelEntityViewParameter, ViewModelEntityViewParameters, ViewModelError, ViewModelMessageButton, ViewModelMessageButtonType, ViewModelMessageType, ViewModelProperties, ViewModelPropertyBase, ViewModelStandardAction, ViewModelToastButton, allOperators, booleanOperators, computed, coreFilterOperatorToModuleFilterOperator, createEnumType, createEnums, createSerializationPlugin, createSubViews, dateOperators, enumOperators, findUIViewPermitter, formatLookupReferenceValue, formatLookupScalarValue, formatLookupScalarValueSync, formatValue, formatValues, getAllowedOperators, getApiClient, getApiClientBaseUrl, getApplicationContext, getClusterLocalStorage, getDataTypeEnumType, getGlobalLocalStorage, getGlobalSearchFunction, getLookupDisplayProperty, getLookupEditingUIViewId, getLookupPropertyFilter, getLookupPropertyPath, getLookupSearchFilter, getLookupSearchProperty, getMenuItemDependencies, getRelationshipCaption, getTenantLocalStorage, getThemeForVsCode, getUIViewPermitter, guidOperators, hasReactivity, initMonacoForVsCodeAsync, initVsCodeOptions, isArrayFilterOperator, isEnumMember, isFilterOperatorOnLookupValueProperty, isFilterOperatorWithoutValue, isInputValueWithWildcards, isLookupContainsSearchActive, isStandardFilterOperator, localizableStringOperators, moduleFilterComponentToCoreFilterComponentView, moduleFilterOperatorToCoreFilterOperator, navigate, nullableOperators, numberOperators, provideForVsCode, reactive, recursiveFindMenuItem, registerApiClient, registerApplicationContext, registerCustomSerializationPlugins, registerUIViewPermitter, reportEvents, runWithEvent, setReactivity, showToast, stringOperators, toggleOverlay, uiViewEvents, watch, writableComputed };

//# sourceMappingURL=core.js.map